import { FC } from "react";
import { Divider, Form } from "antd";
import { StaticFilters } from "../StaticFilters";
import { DYNAMIC_ONEWAY_FILTERS, DYNAMIC_TWOWAY_FILTERS, STATIC_ONEWAY_FILTERS, STATIC_TWOWAY_FILTERS } from "src/Modules/Flights/constants";
import { CheckboxGroup, Range, ResetButton, DynamicFilters } from "src/components/Filters";
import { FormInstance } from "antd/es/form/Form";
import { SegmentCountType } from "src/constants/filters";

export type FiltersBarContentProps = {
  form: FormInstance;
  initialValues: Record<string, any>;
  handleChange: (changedValues: any, allValues: Record<string, any>) => void;
  handleReset: () => void;
  dataCount: SegmentCountType;
  isFetching: boolean;
  dataGroups: any;
  hasReturnFilters: boolean;
  filterComponents: Record<string, { Component: typeof CheckboxGroup | typeof Range; onClear?: (key: string) => void; onReset?: (key: string) => void }>;
};

const FiltersBarContent: FC<FiltersBarContentProps> = ({
  form,
  initialValues,
  handleChange,
  handleReset,
  dataCount,
  isFetching,
  dataGroups,
  hasReturnFilters,
  filterComponents,
}) => {
  return (
    <Form className="m-0! p-0!" onValuesChange={handleChange} initialValues={initialValues} form={form} onReset={handleReset}>
      <ResetButton dataCount={dataCount} isFetching={isFetching} />
      <Divider className="m-0.5! bg-border-minimal!" />
      <StaticFilters filters={STATIC_ONEWAY_FILTERS} />
      <DynamicFilters dataGroups={dataGroups} filters={DYNAMIC_ONEWAY_FILTERS} filterComponents={filterComponents} isFetching={isFetching} />
      {hasReturnFilters && (
        <>
          <StaticFilters filters={STATIC_TWOWAY_FILTERS} />
          <DynamicFilters dataGroups={dataGroups} filters={DYNAMIC_TWOWAY_FILTERS} filterComponents={filterComponents} isFetching={isFetching} />
        </>
      )}
    </Form>
  );
};

export default FiltersBarContent;
